import _ from "lodash";
import { LetPassAccountConstant, LetPassAccountRequiredFieldList } from "presentation/constant/LetPassAccount/LetPassAccountConstant";
import { useLetPassAccountVM } from "presentation/hook/LetPassAccount/useLetPassAccountVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { DropdownProps } from "presentation/model/DropdownProps";
import { useLetPassAccountTracked } from "presentation/store/LetPassAccount/LetPassAccountProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import DateTimePickerComponent from "presentation/view/components/DateTimePickerComponent";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import NumberInputComponent from "presentation/view/components/NumberInputComponent";
import { useCallback, useEffect, useMemo, useState } from "react";
import { FieldType, HPHButton, HPHCheckbox, IconButton, IFieldValue, Loader } from "veronica-ui-component/dist/component/core";
import { SidebarActionBar, SidebarActionCross, Sidebarheader, SidebarTitle } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const LetPassAccountEditPanel = () => {
    const SCREEN_CONSTANT = LetPassAccountConstant;
    const [isLoading, setIsLoading] = useState(false);
    const [letPassAccountState] = useLetPassAccountTracked();
    const letPassAccountVM = useLetPassAccountVM();
    const { currentEditRow, searchCriteria, isEdit, dynamicOptions, masterState } = letPassAccountState;
    const { isSaveClicked, allFormState } = masterState;
    const messageBarVM = useMessageBarVM();
    const { bankCodeDropdownOptions } = dynamicOptions
    useEffect(() => {
        const refreshBankCode = async (bankCodeDropdownOptions: DropdownProps[]) => {
            let defaultBankCode = '';
            if (!_.isEmpty(bankCodeDropdownOptions)) {
                defaultBankCode = bankCodeDropdownOptions[0].value
            }
            letPassAccountVM.onRefreshBankCode(currentEditRow.paymentMode, defaultBankCode)
        }
        if (!!!currentEditRow.id && (currentEditRow.transactionType === 'Deposit' || currentEditRow.transactionType === 'Opening')) {
            refreshBankCode(bankCodeDropdownOptions);
        }
    }, [bankCodeDropdownOptions, currentEditRow.id, currentEditRow.paymentMode, currentEditRow.transactionType, letPassAccountVM])

    useEffect(() => {
        if (currentEditRow.transactionType === 'Closure' && currentEditRow.companyCode) {
            letPassAccountVM.updateTransactionAmount(currentEditRow.companyCode);
        }
    }, [currentEditRow.companyCode, currentEditRow.transactionType, letPassAccountVM])

    const handleSave = useCallback(async () => {
        // if (!currentEditRow.companyCode) {
        //     messageBarVM.showError("CC Company Code is mandatory.");
        //     return;
        // }
        // if (!currentEditRow.paymentMode) {
        //     messageBarVM.showError("Payment Mode is mandatory.");
        //     return;
        // }
        // if (currentEditRow.paymentMode === 'PO' && !currentEditRow.bankCode) {
        //     messageBarVM.showError("Bank Code is mandatory.");
        //     return;
        // }
        // if (currentEditRow.paymentMode === 'PO' && !currentEditRow.payOrderNo) {
        //     messageBarVM.showError("Pay Order No. is mandatory.");
        //     return;
        // }
        // if (currentEditRow.transactionAmount === null) {
        //     messageBarVM.showError("Transaction Amount is mandatory.");
        //     return;
        // }
        // if (!currentEditRow.activeInd) {
        //     messageBarVM.showError("Active Ind is mandatory.");
        //     return;
        // }
        setIsLoading(true);
        letPassAccountVM.onSaveClicked();
        await letPassAccountVM.onSave(currentEditRow).then(data => {
            if (data && data.success) {
                const map = data.data;
                if (map && map['msg']) {
                    messageBarVM.showError(map['msg']);
                }
                if (map && map['lapIds']) {
                    const ids = map['lapIds'];
                    letPassAccountVM.onPrintReport(ids).then(data => {
                        if (data) {
                            messageBarVM.showError(data);
                        } else {
                            messageBarVM.showSuccess("Save successfully.");
                        }
                        setIsLoading(false)
                        letPassAccountVM.onCloseEidtPanel();
                        searchCriteria.companyCode && letPassAccountVM.onSearch(searchCriteria).then((data) => {
                            setIsLoading(false)
                        }).catch(error => {
                            setIsLoading(false)
                        });
                    });
                } else {
                    setIsLoading(false);
                    messageBarVM.showSuccess("Save successfully.");
                    letPassAccountVM.onCloseEidtPanel();
                    searchCriteria.companyCode && letPassAccountVM.onSearch(searchCriteria).then((data) => {
                        setIsLoading(false)
                    }).catch(error => {
                        setIsLoading(false)
                    });
                }
            } else {
                setIsLoading(false)
                messageBarVM.showError(data.data);
                return;
            }
        });
    }, [currentEditRow, letPassAccountVM, messageBarVM, searchCriteria]);

    const handClose = useCallback(() => {
        letPassAccountVM.onCloseEidtPanel();
    }, [letPassAccountVM]);

    const onNumberFieldChange = useCallback((e: any, fieldName: string, fieldValue: any) => {
        letPassAccountVM.onFieldChange(fieldName, fieldValue);
    }, [letPassAccountVM]);

    const memoCompanyCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "280px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isEdit}
                isShowOptional={false}
                readOnlyValue={currentEditRow?.companyCode ?? ''}
                fieldValue={currentEditRow?.companyCode}
                fieldLabel={SCREEN_CONSTANT.CC_COMPANY_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'companyCode'}
                maxLength={60}
                isLimitOptions={true}
                options={letPassAccountState.dynamicOptions.companyCodeDropdownOptions}
                requiredFieldList={LetPassAccountRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    letPassAccountVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), currentEditRow.transactionType)} />
        </div>
        , [SCREEN_CONSTANT.CC_COMPANY_CODE, allFormState, currentEditRow?.companyCode, currentEditRow.transactionType, isEdit, isSaveClicked, letPassAccountState.dynamicOptions.companyCodeDropdownOptions, letPassAccountVM])


    const memoPaymentMode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "280px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isEdit}
                isShowOptional={false}
                readOnlyValue={currentEditRow?.paymentMode ?? ''}
                fieldValue={currentEditRow?.paymentMode}
                fieldLabel={SCREEN_CONSTANT.PAYMENT_MODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'paymentMode'}
                maxLength={60}
                options={letPassAccountState.dynamicOptions.paymentModeDropdownOptions}
                requiredFieldList={LetPassAccountRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    letPassAccountVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.PAYMENT_MODE, allFormState, currentEditRow?.paymentMode, isEdit, isSaveClicked, letPassAccountState.dynamicOptions.paymentModeDropdownOptions, letPassAccountVM])

    const memoBankCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "280px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isEdit || currentEditRow.paymentMode !== 'PO'}
                isShowOptional={false}
                readOnlyValue={currentEditRow?.bankCode ?? ''}
                fieldValue={currentEditRow?.bankCode}
                fieldLabel={SCREEN_CONSTANT.BANK_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'bankCode'}
                maxLength={60}
                options={letPassAccountState.dynamicOptions.bankCodeDropdownOptions}
                requiredFieldList={LetPassAccountRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    letPassAccountVM.onFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.BANK_CODE, allFormState, currentEditRow?.bankCode, currentEditRow.paymentMode, isEdit, isSaveClicked, letPassAccountState.dynamicOptions.bankCodeDropdownOptions, letPassAccountVM])


    const memoTransactionDate = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "280px", marginBottom: "24px" }}>
            <DateTimePickerComponent
                disabled={true}
                label={SCREEN_CONSTANT.TRANSACTION_DATE}
                width="280px"
                date={currentEditRow?.transactionDate}
                fieldName="transactionDate"
                errorMessage={''}
                onDateChange={letPassAccountVM.onFieldChange} />
        </div>
        , [SCREEN_CONSTANT.TRANSACTION_DATE, currentEditRow?.transactionDate, letPassAccountVM.onFieldChange])

    const memoPayOrderNo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "280px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={isEdit || currentEditRow.paymentMode !== 'PO'}
                isShowOptional={false}
                readOnlyValue={currentEditRow.payOrderNo ?? ""}
                fieldValue={currentEditRow?.payOrderNo ?? ""}
                fieldLabel={SCREEN_CONSTANT.PAY_ORDER_NO}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'payOrderNo'}
                maxLength={20}
                requiredFieldList={LetPassAccountRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    letPassAccountVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.PAY_ORDER_NO, allFormState, currentEditRow.payOrderNo, currentEditRow.paymentMode, isEdit, isSaveClicked, letPassAccountVM])

    const memoTransactionAmount = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "280px", marginBottom: "24px" }}>
            <NumberInputComponent
                label={SCREEN_CONSTANT.TRANSACTION_AMOUNT}
                maxLength={13}
                fieldName={"transactionAmount"}
                value={currentEditRow?.transactionAmount ?? ''}
                errorMessage={allFormState ? allFormState["transactionAmount"] : ""}
                disabled={isEdit}
                decimalPlaces={2}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [SCREEN_CONSTANT.TRANSACTION_AMOUNT, allFormState, currentEditRow?.transactionAmount, isEdit, onNumberFieldChange])


    const memoReceiptNo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "280px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEditRow.receiptNo ?? ""}
                fieldValue={currentEditRow?.receiptNo ?? ""}
                fieldLabel={SCREEN_CONSTANT.RECEIPT_NO}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'receiptNo'}
                maxLength={60}
                requiredFieldList={LetPassAccountRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    letPassAccountVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.RECEIPT_NO, allFormState, currentEditRow.receiptNo, isSaveClicked, letPassAccountVM])

    const memoTransactionType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "280px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEditRow.transactionType ?? ""}
                fieldValue={currentEditRow?.transactionType ?? []}
                fieldLabel={SCREEN_CONSTANT.TRANSACTION_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'transactionType'}
                maxLength={60}
                requiredFieldList={LetPassAccountRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    letPassAccountVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.TRANSACTION_TYPE, allFormState, currentEditRow.transactionType, isSaveClicked, letPassAccountVM])

    const memoTransactionDesc = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "280px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEditRow.transactionDesc ?? ""}
                fieldValue={currentEditRow?.transactionDesc ?? []}
                fieldLabel={SCREEN_CONSTANT.TRANSACTION_DESCRIPTION}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'transactionDesc'}
                maxLength={60}
                requiredFieldList={LetPassAccountRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    letPassAccountVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.TRANSACTION_DESCRIPTION, allFormState, currentEditRow.transactionDesc, isSaveClicked, letPassAccountVM])

    const memoCreatedBy = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "280px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={currentEditRow.createdBy ?? ""}
                fieldValue={currentEditRow?.createdBy ?? []}
                fieldLabel={SCREEN_CONSTANT.COLLECTED_BY}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'createdBy'}
                maxLength={60}
                requiredFieldList={LetPassAccountRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    letPassAccountVM.onFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.COLLECTED_BY, allFormState, currentEditRow.createdBy, isSaveClicked, letPassAccountVM])

    const memoActiveInd = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "280px", marginBottom: "24px" }}>
            <NbisCommonField
                fieldKey={"activeInd"}
                requiredFieldList={LetPassAccountRequiredFieldList}
                fieldLabel={SCREEN_CONSTANT.ACTIVE_IND}
                fieldType={FieldType.TEXT}
                isReadOnly={true}
                onFieldChange={() => { }} />
            <HPHCheckbox
                label={""}
                checked={currentEditRow?.activeInd === 'Y'}
                disabled={!isEdit}
                onChange={(e) => letPassAccountVM.onCheckboxChange(e.checked, "activeInd")}
            />
        </div>
        , [SCREEN_CONSTANT.ACTIVE_IND, currentEditRow?.activeInd, isEdit, letPassAccountVM])

    return (
        <div className='side-form-content-wrapper'>
            <div className={'flex-row'}>
                <div className={'flex-row-item flex-row-item-full-width'}>
                    <Sidebarheader>
                        <SidebarTitle>
                            {isEdit ? "Edit" : currentEditRow.transactionType}
                        </SidebarTitle>
                        <SidebarActionCross>
                            <IconButton
                                fileName="Icon-cross" size="medium" toolTipText='Close' toolTipArrow={false} onClick={handClose} />
                        </SidebarActionCross>
                    </Sidebarheader>
                </div>
            </div>
            {isLoading &&
                <Loader Indicator="Spinner" size="Medium" />}
            {!isLoading && <>
                <div className={'add-edit-form'} style={{ height: '75vh', maxHeight: '75vh', overflow: 'auto' }}>
                    <div className="flex-row-auto">
                        <div className={'flex-row-item'}>

                            <CriteriaItemContainer>
                                {memoReceiptNo}
                                {memoCompanyCode}
                            </CriteriaItemContainer>
                            <CriteriaItemContainer>
                                {memoTransactionDate}
                                {memoTransactionType}
                            </CriteriaItemContainer>
                            <CriteriaItemContainer>
                                {memoPaymentMode}
                                {memoBankCode}
                            </CriteriaItemContainer>
                            <CriteriaItemContainer>
                                {memoPayOrderNo}
                                {memoTransactionAmount}
                            </CriteriaItemContainer>
                            <CriteriaItemContainer>
                                {memoTransactionDesc}
                                {memoCreatedBy}
                            </CriteriaItemContainer>
                            <CriteriaItemContainer>
                                {memoActiveInd}
                            </CriteriaItemContainer>

                        </div>
                    </div>
                </div>
                <SidebarActionBar>
                    <HPHButton label={'Close'} size={'Small'} theme={'Secondary'} onClick={handClose} />
                    <HPHButton label={'Save'} size={'Small'} theme={'Primary'} onClick={handleSave} />
                </SidebarActionBar>
            </>}
        </div>
    );
}

export default LetPassAccountEditPanel;
